import Swiper from '../vendors/swiper.min.js';

export default class Sliders {
  static heroSlider() {
    return new Swiper('.hero__slider', {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.hero__pagination',
      }
    });
  }

  static pointSliderOne() {
    return new Swiper('.point__block--one .point__sliderwrap', {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.point__block--one .point__pagination',
      },
      navigation: {
        nextEl: '.point__block--one .point__next',
        prevEl: '.point__block--one .point__prev',
      }
    });
  }

  static pointSliderTwo() {
    return new Swiper('.point__block--two .point__sliderwrap', {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.point__block--two .point__pagination',
      },
      navigation: {
        nextEl: '.point__block--two .point__next',
        prevEl: '.point__block--two .point__prev',
      }
    });
  }
}